export default __webpack_public_path__ + "static/media/kycAnimation.d5b3fa93.gif";